import { render, staticRenderFns } from "./gentle-name-capitalization-dialog.vue?vue&type=template&id=3f24bace&scoped=true&"
import script from "./gentle-name-capitalization-dialog.vue?vue&type=script&lang=js&"
export * from "./gentle-name-capitalization-dialog.vue?vue&type=script&lang=js&"
import style0 from "./gentle-name-capitalization-dialog.vue?vue&type=style&index=0&id=3f24bace&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f24bace",
  null
  
)

export default component.exports